<template lang="pug">

  what-is-this-link
    .card-cvv-help

</template>

<script>
export default {
  name: 'what-is-this-cvv-link'
}
</script>
